<template>
  <div>This feature is not available yet!</div>
</template>

<script>
// @ is an alias to /src
// import SettingsLayout from "@/components/Layout/SettingsLayout";

export default {
  name: "UserEventsView",
  components: {
    // SettingsLayout,
  },
};
</script>
